"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[61],{

/***/ 26946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _typography_span__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51442);


var Div = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_typography_span__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).attrs(function () {
  return {
    as: "div"
  };
}).withConfig({
  displayName: "div__Div",
  componentId: "sc-1i3k5xn-0"
})([""]);
/* harmony default export */ __webpack_exports__["Z"] = (Div);

/***/ }),

/***/ 41717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41289);


var SpaceBetweenWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_typography__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr).attrs(function () {
  return {
    as: "div"
  };
}).withConfig({
  displayName: "space-between-wrapper__SpaceBetweenWrapper",
  componentId: "sc-36pvsy-0"
})(["display:flex;justify-content:space-between;align-items:inherits;", " @media (max-width:520px){", "}"], function (props) {
  return props.noAlignCenter && "align-items: unset;";
}, function (props) {
  return props.mColumn && "flex-direction: column;";
});
/* harmony default export */ __webpack_exports__["Z"] = (SpaceBetweenWrapper);

/***/ }),

/***/ 202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_button_set_v2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.atoms.button/dist/index.js
var dist = __webpack_require__(78483);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.organisms.circular-progress/dist/index.js
var component_2023_components_organisms_circular_progress_dist = __webpack_require__(45631);
// EXTERNAL MODULE: ./src/components/atoms/space-between-wrapper/index.js
var space_between_wrapper = __webpack_require__(41717);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/button-set-v2/button-set-v2.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var NextButton = (0,styled_components_browser_esm["default"])(dist/* default */.ZP).withConfig({
  displayName: "button-set-v2__NextButton",
  componentId: "sc-kghxt6-0"
})(["@media (max-width:520px){", ";}"], function (props) {
  return props.isSingleButton && "width: 100%;";
});
var LoadingStateButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "button-set-v2__LoadingStateButton",
  componentId: "sc-kghxt6-1"
})(["height:48px;background-color:#1F15E1;display:flex;align-items:center;padding:0 20px;border-radius:10px;"]);

var ButtonSetV2 = function ButtonSetV2(_ref) {
  var loading = _ref.loading,
      _ref$secondaryButton = _ref.secondaryButton,
      secondaryButton = _ref$secondaryButton === void 0 ? {} : _ref$secondaryButton,
      _ref$primaryButton = _ref.primaryButton,
      primaryButton = _ref$primaryButton === void 0 ? {} : _ref$primaryButton;
  var primaryButtonId = primaryButton.id,
      primaryButtonTestId = primaryButton.dataTestId,
      primaryButtonText = primaryButton.text,
      primaryButtonVariant = primaryButton.variant,
      primaryButtonType = primaryButton.type,
      primaryButtonEventData = primaryButton.eventData;
  var secondaryButtonId = secondaryButton.id,
      secondaryButtonTestId = secondaryButton.dataTestId,
      secondaryButtonText = secondaryButton.text,
      secondaryButtonVariant = secondaryButton.variant,
      onSecondaryButtonClick = secondaryButton.onClick,
      secondaryButtonClassName = secondaryButton.className,
      secondaryButtonColor = secondaryButton.color,
      secondaryButtonEventData = secondaryButton.eventData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(space_between_wrapper/* default */.Z, {
    width: "100%",
    mt: "15",
    children: [!isEmpty_default()(secondaryButton) ? /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, _objectSpread(_objectSpread({
      id: secondaryButtonId,
      "data-testid": secondaryButtonTestId,
      color: secondaryButtonColor,
      className: secondaryButtonClassName,
      variant: secondaryButtonVariant,
      onClick: onSecondaryButtonClick
    }, secondaryButtonEventData), {}, {
      children: secondaryButtonText
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingStateButton, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(component_2023_components_organisms_circular_progress_dist/* default */.ZP, {
        style: {
          color: "white"
        },
        size: "small"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NextButton, _objectSpread(_objectSpread({
      id: primaryButtonId,
      "data-testid": primaryButtonTestId,
      type: primaryButtonType,
      variant: primaryButtonVariant,
      isSingleButton: isEmpty_default()(secondaryButton)
    }, primaryButtonEventData), {}, {
      children: primaryButtonText
    }))]
  });
};

/* harmony default export */ var button_set_v2 = (ButtonSetV2);
;// CONCATENATED MODULE: ./src/components/molecules/button-set-v2/index.js

/* harmony default export */ var molecules_button_set_v2 = (button_set_v2);

/***/ }),

/***/ 53169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screening_step_v2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/stores/progress/index.js + 1 modules
var progress = __webpack_require__(90296);
// EXTERNAL MODULE: ./src/components/atoms/card/index.js + 1 modules
var card = __webpack_require__(46854);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__(30998);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.organisms.stepper/dist/index.js
var dist = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.organisms.step/dist/index.js
var component_2023_components_organisms_step_dist = __webpack_require__(18667);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.organisms.step-label/dist/index.js
var component_2023_components_organisms_step_label_dist = __webpack_require__(28660);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/organisms/progress-bar-v3/progress-bar-v3.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ProgressBarV2Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "progress-bar-v3__ProgressBarV2Wrapper",
  componentId: "sc-1nvti1h-0"
})(["", ";", ";", ";", ";padding:30px 50px 20px 50px;@media (max-width:520px){white-space:nowrap;overflow:auto;padding:20px 20px 15px 20px;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;}"], function (props) {
  return props.mt && "margin-top: ".concat(props.mt, "px");
}, function (props) {
  return props.mb && "margin-bottom: ".concat(props.mb, "px");
}, function (props) {
  return props.mr && "margin-right: ".concat(props.mr, "px");
}, function (props) {
  return props.ml && "margin-left: ".concat(props.ml, "px");
});

var ProgressBarV3 = function ProgressBarV3(_ref) {
  var steps = _ref.steps;

  var _useState = (0,react.useState)(steps),
      stepsState = _useState[0],
      setStepsState = _useState[1];

  var _useState2 = (0,react.useState)(0),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var router = (0,next_router.useRouter)();
  var scrollContainerRef = (0,react.useRef)(null);
  var stepperRef = {
    stepper0Ref: (0,react.useRef)(null),
    stepper1Ref: (0,react.useRef)(null),
    stepper2Ref: (0,react.useRef)(null)
  };

  var setStepPosition = function setStepPosition(currentStepIndex) {
    var step0Width = stepperRef.stepper0Ref.current.getBoundingClientRect().width;
    var step1Width = stepperRef.stepper1Ref.current.getBoundingClientRect().width;
    var refContainer = scrollContainerRef.current;
    var distanceFromLeftToCenter = 40 + step0Width + step1Width / 2;
    var scrollContainerWidth = refContainer.getBoundingClientRect().width;
    var scrollToPosition = 0;

    if (currentStepIndex == 1) {
      scrollToPosition = distanceFromLeftToCenter - scrollContainerWidth / 2;
    } else if (currentStepIndex == 2) {
      scrollToPosition = 1000;
    }

    refContainer.scrollTo({
      left: scrollToPosition,
      behavior: "smooth"
    });
  };

  (0,react.useEffect)(function () {
    var currentStepIndex = findIndex_default()(stepsState, function (step) {
      return (router === null || router === void 0 ? void 0 : router.pathname) === (step === null || step === void 0 ? void 0 : step.pathname);
    });
    setStepPosition(currentStepIndex);
    setActiveStep(currentStepIndex);
    var steps = stepsState.map(function (step, index) {
      if (index < currentStepIndex) {
        return _objectSpread(_objectSpread({}, step), {}, {
          status: "complete"
        });
      } else if (index == currentStepIndex) {
        return _objectSpread(_objectSpread({}, step), {}, {
          status: "active"
        });
      } else if (index > currentStepIndex) {
        return _objectSpread(_objectSpread({}, step), {}, {
          status: "inactive"
        });
      }

      return step;
    });
    setStepsState(steps);
  }, [stepperRef.stepper0Ref.current, stepperRef.stepper1Ref.current, stepperRef.stepper2Ref.current]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressBarV2Wrapper, {
    ref: scrollContainerRef,
    mr: 10,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, {
      style: {
        marginRight: "50px"
      },
      activeStep: activeStep,
      viewMode: "mobile",
      children: stepsState.map(function (step, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(component_2023_components_organisms_step_dist/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            ref: stepperRef["stepper".concat(index, "Ref")],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(component_2023_components_organisms_step_label_dist/* default */.ZP, {
              status: step.status,
              children: step.label
            })
          })
        }, "stepper-".concat(index));
      })
    })
  });
};

/* harmony default export */ var progress_bar_v3 = (ProgressBarV3);
;// CONCATENATED MODULE: ./src/components/organisms/progress-bar-v3/index.js

/* harmony default export */ var organisms_progress_bar_v3 = (progress_bar_v3);
// EXTERNAL MODULE: ./src/styles/style-constants.js
var style_constants = __webpack_require__(73569);
;// CONCATENATED MODULE: ./src/components/templates/screening-step-v2/index.js

var _excluded = ["children"];









var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "screening-step-v2__Wrapper",
  componentId: "sc-xb78pt-0"
})(["padding-left:56px;padding-right:56px;padding-bottom:30px;height:100%;box-sizing:border-box;display:flex;flex-direction:column;.screeningOptionNextBtn,.important-text{display:none;}.screeningOptionNextBtnSet{display:flex;}@media (max-width:520px){margin:0px;height:unset;padding:0 16px 19px 16px;.screeningOptionNextBtn{display:flex;margin-top:32px;}.important-text{display:flex;}.screeningOptionNextBtnSet{display:none;}}"]);

var ScreeningStepV2 = function ScreeningStepV2(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var progressStep = (0,recoil/* useRecoilValue */.sJ)(progress/* selectProgressStepV2 */.K);
  var router = (0,next_router.useRouter)();
  var partner = router.query.partner;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
    width: "760px",
    height: "586px",
    MaxHeight: "760px",
    mWidth: "100%",
    mMaxWidth: "100%",
    mHeight: "100vh",
    mMaxHeight: "none",
    mBorder: "none",
    mNoShadow: true,
    radius: "16px",
    border: "1px solid ".concat(style_constants/* COLOR.deepBluePale */.r$.deepBluePale),
    boxShadow: style_constants/* SHADOW_LV1 */._9,
    mUnsetHeight: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(organisms_progress_bar_v3, {
      steps: progressStep
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: children
    })]
  });
};

/* harmony default export */ var screening_step_v2 = (ScreeningStepV2);

/***/ }),

/***/ 88372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ PATH; }
/* harmony export */ });
var PATH = {
  PROPERTY: "property",
  APPLICANT: "applicant",
  FINISH: "finish"
};

/***/ }),

/***/ 93383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ formReadyState; },
/* harmony export */   "m": function() { return /* binding */ formReadyStateV2; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2804);

var formReadyState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
  key: "formReadyState",
  "default": {
    screeningOption: false,
    property: false,
    applicant: false
  }
});
var formReadyStateV2 = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
  key: "formReadyStateV2",
  "default": {
    screeningOption: false,
    property: false,
    applicant: false
  }
});


/***/ }),

/***/ 90296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ selectProgressStep; },
  "K": function() { return /* binding */ selectProgressStepV2; }
});

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./src/stores/form-ready/index.js
var form_ready = __webpack_require__(93383);
// EXTERNAL MODULE: ./src/stores/tenant-screening/index.js + 1 modules
var tenant_screening = __webpack_require__(76770);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/utils/progress-generator.js

function progressGenerator(tenantScreeningData, formReady) {
  var screeningOption = tenantScreeningData.screeningOption,
      property = tenantScreeningData.property,
      agentEmail = tenantScreeningData.agentEmail,
      renterEmails = tenantScreeningData.renterEmails;
  return [{
    name: "Screening",
    pathname: "/[partner]",
    ready: !isEmpty_default()(screeningOption) || (formReady === null || formReady === void 0 ? void 0 : formReady.screeningOption)
  }, {
    name: "Rental",
    pathname: "/[partner]/property",
    ready: !isEmpty_default()(property) || (formReady === null || formReady === void 0 ? void 0 : formReady.property)
  }, {
    name: "Applications",
    pathname: "/[partner]/applicant",
    ready: !!(agentEmail && !isEmpty_default()(renterEmails) || formReady !== null && formReady !== void 0 && formReady.applicant)
  }];
}
function progressGeneratorV2(tenantScreeningData, formReady) {
  var screeningOption = tenantScreeningData.screeningOption,
      property = tenantScreeningData.property,
      agentEmail = tenantScreeningData.agentEmail,
      renterEmails = tenantScreeningData.renterEmails;
  return [{
    status: !isEmpty_default()(screeningOption) || formReady !== null && formReady !== void 0 && formReady.screeningOption ? "complete" : "inactive",
    label: '1. Screening options',
    pathname: "/[partner]/v2"
  }, {
    status: !isEmpty_default()(property) || formReady !== null && formReady !== void 0 && formReady.property ? "complete" : "inactive",
    label: '2. Property info',
    pathname: "/[partner]/v2/property"
  }, {
    status: !!(agentEmail && !isEmpty_default()(renterEmails) || formReady !== null && formReady !== void 0 && formReady.applicant) ? "complete" : "inactive",
    label: '3. Applicant info',
    pathname: "/[partner]/v2/applicant"
  }];
}
;// CONCATENATED MODULE: ./src/stores/progress/index.js




var selectProgressStep = (0,recoil/* selector */.nZ)({
  key: "selectProgressStep",
  get: function get(_ref) {
    var _get = _ref.get;
    return progressGenerator(_get(tenant_screening/* tenantScreeningState */.A), _get(form_ready/* formReadyState */.H));
  }
});
var selectProgressStepV2 = (0,recoil/* selector */.nZ)({
  key: "selectProgressStepV2",
  get: function get(_ref2) {
    var _get2 = _ref2.get;
    return progressGeneratorV2(_get2(tenant_screening/* tenantScreeningStateV2 */.c), _get2(form_ready/* formReadyState */.H));
  }
});


/***/ }),

/***/ 98337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eR": function() { return /* binding */ validateLength; },
/* harmony export */   "iA": function() { return /* binding */ validateRequestReportEmail; },
/* harmony export */   "nc": function() { return /* binding */ requiredYup; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "zA": function() { return /* binding */ removeSpaceCommaFromArray; }
/* harmony export */ });
/* unused harmony exports getFormatMessage, validateDuplicateValues, removeSpaceCommaFromString */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64720);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82644);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44012);
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1469);
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47037);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13880);
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48966);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(validator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84782);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* .createIntl */ .d)({}, (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* .createIntlCache */ .Sn)());
var requiredYup = function requiredYup() {
  var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var yupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)();
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "normal";

  if (required) {
    var errorMessage = _messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].required */ .Z.required;
    return yupType.required( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, errorMessage)));
  }

  return yupType;
};
var validateEmail = function validateEmail() {
  var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var validate = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().email( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, _messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].invalidEmail */ .Z.invalidEmail))).max(255, getFormatMessage(_messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].maxChar */ .Z.maxChar, {
    max: 255
  }));
  return requiredYup(required, validate);
};
var validateLength = function validateLength() {
  var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 35;
  var validate = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().min(min, getFormatMessage(_messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].minChar */ .Z.minChar, {
    min: min
  })).max(max, getFormatMessage(_messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].maxChar */ .Z.maxChar, {
    max: max
  }));
  return requiredYup(required, validate);
};
var getFormatMessage = function getFormatMessage(messageDescriptor, value) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, messageDescriptor), {}, {
    defaultMessage: intl.formatMessage(messageDescriptor, value)
  }));
};
var validateDuplicateValues = function validateDuplicateValues(values) {
  if (Array.isArray(values) && values.length > 0) return new Set(values).size === values.length;
  return true;
};
var validateRequestReportEmail = function validateRequestReportEmail() {
  var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var validate = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)().of((0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().test({
    name: "validateEmailFormat",
    message: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, _messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].invalidEmail */ .Z.invalidEmail)),
    test: function test(value) {
      return (0,validator__WEBPACK_IMPORTED_MODULE_10__.isEmail)(value.trim());
    }
  })).min(1, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, _messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].required */ .Z.required))).test({
    name: "duplicateEmails",
    message: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, _messages__WEBPACK_IMPORTED_MODULE_5__/* ["default"].duplicateEmails */ .Z.duplicateEmails)),
    test: function test(values) {
      return validateDuplicateValues(values);
    }
  });
  return requiredYup(required, validate);
};
var removeSpaceCommaFromArray = function removeSpaceCommaFromArray(array) {
  if (!lodash_isArray__WEBPACK_IMPORTED_MODULE_2___default()(array)) return array;
  return array.map(function (string) {
    return removeSpaceCommaFromString(string);
  });
};
var removeSpaceCommaFromString = function removeSpaceCommaFromString(string) {
  if (!lodash_isString__WEBPACK_IMPORTED_MODULE_3___default()(string)) return string;
  return lodash_replace__WEBPACK_IMPORTED_MODULE_4___default()(string, /\s+|,+/g, "");
};

/***/ }),

/***/ 84782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export messages */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54490);

var messages = {
  required: {
    id: "required",
    defaultMessage: "Required"
  },
  radioRequired: {
    id: "radio-required",
    defaultMessage: "Please select one option"
  },
  minChar: {
    id: "minChar",
    defaultMessage: "Must contains at least {min} characters",
    values: {
      min: 2
    }
  },
  maxChar: {
    id: "maxChar",
    defaultMessage: "Must not exceed {max} characters",
    values: {
      max: 35
    }
  },
  dobNoFuture: {
    id: "dobNoFuture",
    defaultMessage: "Date of birth cannot be in the future"
  },
  invalidZipCode: {
    id: "invalidZipCode",
    defaultMessage: "Allow only 5 digit number"
  },
  invalidState: {
    id: "invalidState",
    defaultMessage: "Invalid state code"
  },
  invalidEmail: {
    id: "invalidEmail",
    defaultMessage: "Invalid email format"
  },
  invalidEmailChar: {
    id: "invalidEmailChar",
    defaultMessage: "Email contains invalid character"
  },
  duplicateEmails: {
    id: "duplicateEmails",
    defaultMessage: "Duplicate emails are not allowed"
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)(messages));

/***/ })

}]);